/** Traductions modèles HTML printService (FR / AR) */
export const printServicePageFr = {
  receiptTitle: 'REÇU',
  invoiceTitle: 'FACTURE',
  date: 'Date',
  saleId: 'N° vente',
  item: 'Article',
  noItems: 'Aucun article',
  total: 'TOTAL',
  from: 'De',
  businessName: 'Nom de l\'entreprise',
  address: 'Adresse',
  invoiceDetails: 'Détails facture',
  invoiceNumber: 'N° facture',
  dueDate: 'Échéance',
  colItem: 'Article',
  colQuantity: 'Qté',
  colPrice: 'Prix',
  colTotal: 'Total',
  subtotal: 'Sous-total',
  tax: 'Taxe',
  totalLabel: 'Total',
  addressNotSpecified: 'Adresse non spécifiée',
  phoneNotSpecified: 'Téléphone non spécifié'
};

export const printServicePageAr = {
  receiptTitle: 'إيصال',
  invoiceTitle: 'فاتورة',
  date: 'التاريخ',
  saleId: 'رقم البيع',
  item: 'منتج',
  noItems: 'لا توجد منتجات',
  total: 'الإجمالي',
  from: 'من',
  businessName: 'اسم النشاط',
  address: 'العنوان',
  invoiceDetails: 'تفاصيل الفاتورة',
  invoiceNumber: 'رقم الفاتورة',
  dueDate: 'تاريخ الاستحقاق',
  colItem: 'المنتج',
  colQuantity: 'الكمية',
  colPrice: 'السعر',
  colTotal: 'المجموع',
  subtotal: 'المجموع الفرعي',
  tax: 'الضريبة',
  totalLabel: 'الإجمالي',
  addressNotSpecified: 'العنوان غير محدد',
  phoneNotSpecified: 'الهاتف غير محدد'
};
